import { Box } from '@mui/material';
import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { formatNumber, NumberFormatPreset, useCurrency } from '@procureai/ui-mui';
import { isNil } from 'ramda';
import { Union } from 'ts-toolbelt';

import { NBSP } from '~/common/constants';
import { StatusUnion } from '~/common/types';
import { NULLISH_CELL_VALUE } from '~/components/DataGridCustom/DataGridCustom.types';
import { colorFromStatus } from '~/util/conversion';

const formatPct = formatNumber(NumberFormatPreset.PERCENT_DECIMAL);

export type DiscountCellValue = Union.Nullable<number>;

interface DiscountCellProps<R extends GridValidRowModel = any> {
  value: DiscountCellValue;
  row: R;
  percent: Union.Nullable<number>;
  currency?: Union.Nullable<string>;
  status?: Union.Nullable<StatusUnion>;
}

export const DiscountCell = <R extends GridValidRowModel = any>({
  value,
  currency,
  percent,
  status,
}: DiscountCellProps<R>) => {
  const { format } = useCurrency({
    code: currency,
  });
  if (!isNil(value)) {
    const statusColor = status ? colorFromStatus(status) : undefined;
    return (
      <Box
        component="span"
        sx={{
          color: statusColor && `${statusColor}.main`,
        }}
      >
        {format(value)}
        {isNil(percent) ? null : `${NBSP}(${formatPct(percent)})`}
      </Box>
    );
  }
  return <>{NULLISH_CELL_VALUE}</>;
};
